import { KeyboardTimePicker, TimePickerProps } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { FieldInputProps, FormikProps, FormikValues, getIn } from "formik";
import * as React from "react";
import { THEME } from "../../theme/ThemeStore";

type Props<Values extends FormikValues> = TimePickerProps & {
    field: FieldInputProps<string>;
    form: FormikProps<Values>;
    middleText: boolean;
};

export const CustomTimePicker = <Values extends FormikValues>({
    style,
    label,
    autoComplete,
    required,
    disabled,
    InputLabelProps,
    inputProps,
    field,
    form,
    middleText,
    placeholder,
    onChange,
    onBlur,
    onAccept,
    ...props
}: Props<Values>) => {
    const fieldError = getIn(form.errors, field.name);
    const showError = getIn(form.touched, field.name) && !!fieldError;

    const handleChange = (time: MaterialUiPickersDate) => {
        form.setFieldValue(field.name, time, true);

        if (onChange) {
            onChange(time);
        }
    };

    return (
        <div
            style={{
                flexBasis: 0,
                width: "100%",
                flexGrow: 1,
                ...style
            }}
        >
            <KeyboardTimePicker
                label={label}
                autoOk
                value={field.value}
                name={field.name}
                placeholder={placeholder}
                onChange={handleChange}
                onBlur={(event: React.FocusEvent<any>) => {
                    field.onBlur(event);
                    if (onBlur) {
                        onBlur(event);
                    }
                }}
                onAccept={onAccept}
                ampm={false}
                InputLabelProps={InputLabelProps}
                helperText={""}
                fullWidth
                error={showError}
                inputVariant="filled"
                DialogProps={{
                    PaperProps: {
                        className: "timePicker blackDalBorder"
                    }
                }}
                inputProps={
                    middleText
                        ? {
                              style: {
                                  padding: "0 0 0 12px",
                                  textAlign: THEME.THEME_NAME === "dal" ? "start" : "center"
                              }
                          }
                        : undefined
                }
                InputProps={{
                    disableUnderline: true,
                    style: {
                        borderBottom: !label && showError ? `2px solid ${THEME.customColors.error}` : undefined,
                        borderTop: !label && showError ? `2px solid transparent` : undefined,
                        paddingRight: 4
                    }
                }}
                InputAdornmentProps={{
                    style: {
                        marginLeft: 0
                    }
                }}
                KeyboardButtonProps={{
                    style: {
                        padding: 9,
                        opacity: 0.7
                    }
                }}
                style={{
                    color: THEME.customColors.white
                }}
                keyboardIcon={<img src={THEME.Images.icTime} alt="" />}
            />
        </div>
    );
};
